<template>
  <v-app style="background:#eee;">
    <v-app-bar color="blue-grey" dense dark app>
      <v-app-bar-nav-icon @click.stop="compSelectBoxVis = !compSelectBoxVis"></v-app-bar-nav-icon>
      <v-toolbar-title style="font-size:1rem;width:95%;padding-left:0.4rem;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">运维平台
          <span v-if="companyInfo"> - {{companyInfo.COMPANY_NAME}}</span>
        </span>
        <!-- <span style="position: absolute;top:0.545rem;color:#fff !important;">运维平台</span> -->
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon @click="goOrderList">
        <v-badge color="red accent-2" offset-x="9" offset-y="7" dot>
          <v-icon>mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn> -->
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <!-- <v-icon>mdi-dots-vertical</v-icon> -->
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-list style="padding:0;">
          <!-- <v-list-item @click="copyUserLocalData">
            <v-list-item-title style="font-size:0.85rem;" class="us-clipboard" data-clipboard-text="64354">复制用户本地数据</v-list-item-title>
          </v-list-item> -->
          <v-list-item @click="goInvite" class="us-list-item">
            <v-list-item-title class="us-list-item-title">
              <i class="fa fa-paper-plane" />
              <span>邀请新团员</span>
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="goScanQrcode" class="us-list-item">
            <v-list-item-title class="us-list-item-title">
              <!-- <i class="fa fa-qrcode" style="position:absolute;top:3px;left:2px;color:#9e9e9e;" /> -->
              <v-icon>mdi-qrcode-scan</v-icon>
              <span>扫一扫 绑定设备</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-content>
      <v-container>
        <FollowPublicAccount v-if="followVis" />
        <div v-else>
          <StatDeviceCount v-if="!loading" />
          <div style="margin:1rem 0;"></div>
          <ApDeviceTags v-if="companyInfo.COMPANY_CODE == 'CY2310101819430805'"/>
          <div style="margin:1rem 0;"></div>
          <DeviceTagsChart v-if="!loading" />
          <div style="margin:1rem 0;"></div>
          <FlowDeviceList v-if="!loading" />
          <div style="margin:1rem 0;"></div>
          <DeviceNotifyList v-if="!loading" />
          <div style="margin:1rem 0;"></div>
          <!-- <DeviceList v-if="!loading" /> -->
          <HostDeviceList v-if="!loading" />
          <div style="margin:1rem 0;"></div>
          <LastOrderList v-if="!loading" />
          <div style="margin-bottom:6rem;margin-top:0.8rem;"></div>
          <div class="us-create-btn" @click="goCreateOrder">
            <v-btn dark fab right color="#5cbbf6"><v-icon>mdi-plus</v-icon></v-btn>
          </div>
          <!-- <div v-if="companyInfo.COMPANY_CODE == 'CY2310101819430805'" style="position:fixed;bottom: 8.5rem;right: 1.5rem;" @click="goApDevice">
            <v-btn dark fab right color="#5cbbf6">
              <v-img style="width:56px;height:100%;" :src="$iconPath + '/ap_wireless.png'" />
            </v-btn>
          </div> -->
          <LeftDrawer :visible.sync="leftDrawerVis" @company-toggled="companyToggled" />
          <CompanySelectBox v-if="!loading" :visible.sync="compSelectBoxVis" @company-toggled="companyToggled" />
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import wx from 'weixin-js-sdk'
import LeftDrawer from '@/components/Drawer'
import StatDeviceCount from './components/StatDeviceCount'
import LastOrderList from './components/LastOrderList'
// import DeviceList from './components/DeviceList'
import DeviceNotifyList from './components/DeviceNotifyList_v3'
import DeviceTagsChart from './components/DeviceTagsChart'
import FollowPublicAccount from './components/FollowPublicAccount'
import CompanySelectBox from '@/components/CompanySelectBox'
import HostDeviceList from './components/HostDeviceList'
import ApDeviceTags from '../Biz/Ap/components/ApDeviceTags.vue'
import FlowDeviceList from '../Biz/Flow/components/FlowDeviceList.vue'

export default {
  name: 'Home',
  components: {
    LeftDrawer,
    StatDeviceCount,
    LastOrderList,
    // DeviceList,
    DeviceNotifyList,
    DeviceTagsChart,
    FollowPublicAccount,
    CompanySelectBox,
    HostDeviceList,
    ApDeviceTags,
    FlowDeviceList
  },
  data: () => ({
    leftDrawerVis: false,
    companyInfo: {},
    loading: true,
    userInfo: {},
    followVis: false,
    compSelectBoxVis: false
  }),
  methods: {
    goOrderList() {
      this.$router.goPage('/OrderList')
    },
    goCreateOrder() {
      this.$router.goPage('/CreateOrder')
    },
    // 测试复制数据
    copyUserLocalData() {
      var that = this
      var customData = that.$AppHelper.getCustomData();
      var tokenInfo = that.$AppHelper.getUserTokenInfo();
      customData.TokenInfo = tokenInfo;
      var retText = JSON.stringify(customData);
      var clipboard = new that.$clipboard('.us-clipboard', {
        text: function() {
          return retText
        }
      });
      clipboard.on('success', function() {
        that.$toast.success('复制成功')
      });
      clipboard.on('error', function() {
        that.$toast.warning('复制失败')
      });
    },
    goUserProfile() {
      this.$router.goPage('/UserProfile')
    },
    goDeviceList() {
      this.$router.goPage('/DeviceList')
    },
    goHome() {
      this.$router.goPage('/Home')
    },
    init() {
      var that = this
      that.$store.commit('SET_FNAVVAL', 0)
      // that.userInfo = that.$AppHelper.getCustomData('user_info');
      // console.log('userInfo', that.userInfo);
      that.loading = true
      that.$nextTick(function() {
        that.$AppHelper.pullUserCustomData(function(data) {
          that.companyInfo = data.company_info;
          that.userInfo = data.user_info;
          that.getFollowPublicAccount()
          that.loading = false
        });
      })
    },
    // 切换企业成功事件
    companyToggled(code) {
      var that = this
      if (!code) {
        return
      }
      that.loading = true
      that.$nextTick(function() {
        that.companyInfo = that.$AppHelper.getCustomData('company_info');
        that.loading = false
      })
    },
    // 是否管理员权限
    hasPermission() {
      var that = this
      if (that.companyInfo.COMPANY_ADMIN_CODE !== that.userInfo.usercode) {
        that.$toast.warning('只有管理员才可以操作');
        return false
      }
      return true
    },
    // 邀请新团员
    async goInvite() {
      var that = this
      if (!that.hasPermission()) {
        return
      }
      var expiry = 30
      var res = await that.$api.bz.createCompanyInvite({ company_code: that.companyInfo.COMPANY_CODE, invite_expiry: expiry, s_role: 'common' })
      // console.log('生成企业邀请码', res)
      if (!res.success) {
        // that.$toast.error('生成团队邀请码失败')
        console.log('生成团队邀请码失败', res);
        that.$toast.warning('生成邀请二维码失败');
        return
      }
      var data = res.data
      var query = { code: that.companyInfo.COMPANY_CODE, name: that.companyInfo.COMPANY_NAME, qrcode: data, expiry: expiry }
      that.$router.goPage({ path: '/CompanyInvite', query: query })
    },
    // 扫一扫二维码
    goScanQrcode() {
      const that = this
      if (!that.hasPermission()) {
        return
      }
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: async function(res) {
          const result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          if (result === '') {
            that.$toast.warning('二维码不能为空')
            return
          }
          if (result.substring(0, 4) === 'http') {
            // 如果是微信短地址，就尝试去获取完整地址，避免直接跳转访问微信短地址有一瞬间空白画面
            var full_url = await that.getShareFullUrl(result)
            if (full_url) {
              window.location.href = full_url
            } else {
              window.location.href = result
            }
            return
          }
          that.$toast.success(result);
        }
      })
    },
    // 获取分享完整地址. (参数url：微信短地址)
    async getShareFullUrl(url) {
      var that = this
      var res = await that.$api.bz.getShareFullUrl({ s_url: url })
      if (!res.success) {
        return ''
      }
      // that.$toast.success(res.data);
      return res.data
    },
    // 获取微信公众号关注情况
    async getFollowPublicAccount() {
      var that = this
      var userInfo = that.$AppHelper.getCustomData('user_info');
      var res = await that.$api.gzh.getFollowPublicAccount({ openid: userInfo.openid })

      if (!res.success) {
        console.log('获取微信公众号关注情况出错了', res)
        return
      }

      if (res.data === false) {
        that.followVis = true
      }
    }
  },
  created() {
  },
  mounted() {
    var that = this
    that.init()
  },
  activated() {
    var that = this
    that.$store.commit('SET_FNAVVAL', 0)
    if (!that.$router.isBack) {
      window.scroll(0, 0);
    }
  },
  deactivated() {
  }
}

</script>

<style scoped>
.us-create-btn{
  position:fixed;
  bottom: 4.5rem;
  right: 1.5rem;

}
</style>
